export interface Dependent {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy: CreatedBy;
  dependentName: string;
  relationship: string;
  gender: string;
  dateOfBirth: string;
  idCardNo: string;
  taxCode: string;
  registerForPITDeduction: boolean;
  address: string;
  employeeId: number;
  nationalityId: number;
  provinceId?: number;
  districtId?: number;
  wardId?: number;
  organizationId: number;
  effectiveFrom: string;
  effectiveTo: string;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface DependentListRequest {
  employeeId: number;
  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
}

export interface DependentCreateRequest {
  employeeId: number;
  dependentName: string;
  relationship: string;
  gender: string;
  dateOfBirth: string;
  idCardNo: string;
  taxCode?: string;
  registerForPITDeduction: boolean;
  nationalityId: number;
  provinceId?: number;
  districtId?: number;
  wardId?: number;
  address: string;
  effectiveFrom: string;
  effectiveTo: string;
}

export interface DependentUpdateRequest extends DependentCreateRequest {
  id: string;
}

export interface DependentListResponse extends RestAPIMetaResponse {
  items: Array<Dependent>;
}

export enum DependentRelationship {
  Child = "Child",
  AdoptiveChild = "AdoptiveChild",
  Father = "Father",
  Mother = "Mother",
  FatherInLaw = "FatherInLaw",
  MotherInLaw = "MotherInLaw",
  AdoptiveFather = "AdoptiveFather",
  AdoptiveMother = "AdoptiveMother",
  StepFather = "StepFather",
  StepMother = "StepMother",
  Wife = "Wife",
  Husband = "Husband",
  Brother = "Brother",
  Sister = "Sister",
  Niece = "Niece",
  Nephew = "Nephew",
  Grandpa = "Grandpa",
  Grandma = "Grandma",
  Aunt = "Aunt",
  Uncle = "Uncle",
  Others = "Others",
}

export enum DependentGender {
  Male = "Male",
  Female = "Female",
  Other = "Other",
}
